import { render } from "./toDoList.vue?vue&type=template&id=87eb90ce&scoped=true"
import script from "./toDoList.vue?vue&type=script&lang=js"
export * from "./toDoList.vue?vue&type=script&lang=js"

import "./toDoList.vue?vue&type=style&index=0&id=87eb90ce&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87eb90ce"]])

export default __exports__